// ── Tipatask web frontend entry ──

import './styles.css';
import { addRoute, start, navigate, resolve } from './router.js';
import { bootTheme } from './ui.js';
import { boardPage } from './pages/board.js';
import { dashboardPage } from './pages/dashboard.js';
import { epicsPage } from './pages/epics.js';
import { settingsPage } from './pages/settings.js';
import { securitySettingsPage } from './pages/security-settings.js';
import { profilePage } from './pages/profile.js';
import { backlogPage } from './pages/backlog.js';
import { taskDetailPage } from './pages/task-detail.js';
import { workspaceTasksPage } from './pages/workspace-tasks.js';
import { sprintPlanningPage } from './pages/sprint-planning.js';
import { renderServerAgentPage } from './pages/server-agent.js';
import { loginPage } from './pages/login.js';
import { registerPage } from './pages/register.js';
import { invitePage, consumePendingInvite } from './pages/invite.js';
import { openReauthModal } from './components/reauth-modal.js';
import { initPwaInstall } from './pwa-install.js';

// ── Init theme before first render (anti-flash — reads project id straight off hash) ──
bootTheme();

// ── Global 401 re-auth handler ──
// api.js dispatches 'auth:expired' only for a browser with a confirmed prior
// session (HAD_SESSION_KEY — a first-time visitor's 401 skips this entirely
// and goes straight to /login, C1249). The modal's one action sends the user
// to the full sign-in page — it no longer completes in place, so there is no
// onComplete path to re-resolve the current route from.
let _reauthModalOpen = false;
window.addEventListener('auth:expired', () => {
  if (_reauthModalOpen) return;
  _reauthModalOpen = true;
  openReauthModal({
    onCancel: () => {
      _reauthModalOpen = false;
      navigate('/login');
    },
  });
});

// ── Register routes (most specific first) ──

addRoute('/login', loginPage);
addRoute('/register', registerPage); // TPT96 — beta registration entry point, optional ?code=
addRoute('/invite/:token', invitePage);
addRoute('/account/security', securitySettingsPage);
addRoute('/profile', profilePage);
addRoute('/workspace/tasks', workspaceTasksPage);
addRoute('/projects/:id/settings', settingsPage);
addRoute('/projects/:id/tasks/:taskKey', taskDetailPage);
addRoute('/projects/:id/sprint-planning', sprintPlanningPage);
addRoute('/projects/:id/server-agent', renderServerAgentPage);
addRoute('/projects/:id/backlog', backlogPage);
addRoute('/projects/:id/epics', epicsPage);
addRoute('/projects/:id/board', boardPage);
addRoute('/projects/:id', boardPage);
// A token stashed in invite.js before bouncing through /login (logged-out
// visitor, or the Google OAuth full-page redirect) is replayed here — both
// paths land back on '/' once a session exists (C1168).
addRoute('/', (params) => (consumePendingInvite() ? null : dashboardPage(params)));

start();

if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js');
initPwaInstall();
